import { PlatformQuery } from "@shared/models/platform-query/platform-query";

export class ScenarioActivityQueryFactory {
  static getScenarioActivityQuery(scenarioId: string): PlatformQuery {
    let platformQuery = new PlatformQuery();
    platformQuery.name = "GetScenarioActivityQuery";
    platformQuery.api = "SpreadsheetApi";
    platformQuery.fieldValues["ScenarioId"] = scenarioId;
    return platformQuery;
  }
}
